import React, { useEffect, useRef } from 'react';
import { portfolioItems } from './portfolioData';
import { Link } from 'react-router-dom';
import Isotope from 'isotope-layout';

const PortfolioSection = () => {
  const isotopeRef = useRef(null);

  useEffect(() => {
    // Small delay to ensure DOM is ready
    const initTimeout = setTimeout(() => {
      const portfolioContainer = document.querySelector('.portfolio-container');
      
      if (portfolioContainer && !isotopeRef.current) {
        // Wait for all images to load before initializing Isotope
        const images = portfolioContainer.querySelectorAll('img');
        const imagePromises = Array.from(images).map((img) => {
          return new Promise((resolve) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve; // Resolve even on error to continue
            }
          });
        });

        Promise.all(imagePromises).then(() => {
          if (!isotopeRef.current && portfolioContainer) {
            isotopeRef.current = new Isotope(portfolioContainer, {
              itemSelector: '.portfolio-item',
              layoutMode: 'fitRows',
              percentPosition: true,
              fitRows: {
                gutter: 0
              }
            });

            // Force layout calculation
            setTimeout(() => {
              if (isotopeRef.current) {
                isotopeRef.current.layout();
              }
            }, 250);
          }
        });
      }
    }, 100);

    // Setup filter click handlers
    const portfolioFilters = document.querySelectorAll('#portfolio-flters li');
    
    const handleFilterClick = (e) => {
      e.preventDefault();
      portfolioFilters.forEach((el) => {
        el.classList.remove('filter-active');
      });
      e.currentTarget.classList.add('filter-active');

      if (isotopeRef.current) {
        isotopeRef.current.arrange({
          filter: e.currentTarget.getAttribute('data-filter')
        });
        // Recalculate layout after filter
        setTimeout(() => {
          if (isotopeRef.current) {
            isotopeRef.current.layout();
          }
        }, 50);
      }
    };

    portfolioFilters.forEach((filter) => {
      filter.addEventListener('click', handleFilterClick);
    });

    // Cleanup
    return () => {
      clearTimeout(initTimeout);
      portfolioFilters.forEach((filter) => {
        filter.removeEventListener('click', handleFilterClick);
      });
      if (isotopeRef.current) {
        isotopeRef.current.destroy();
        isotopeRef.current = null;
      }
    };
  }, []);

  return (
    <div id="portfolio" className="paddsection">
      <div className="container">
        <div className="section-title text-center">
          <h2>Portfolio</h2>
            <span className="separator">Featured Projects & Case Studies</span>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center">
            <ul id="portfolio-flters">
              <li data-filter="*" className="filter-active">All</li>
              <li data-filter=".filter-web">Web</li>
              <li data-filter=".filter-app">App</li>
              <li data-filter=".filter-card">Other</li>
            </ul>
          </div>
        </div>
        <div className="row portfolio-container">
              {/* Loop through portfolioItems array and render each portfolio item */}
              {portfolioItems.map(item => (
            <div key={item.id} className={`col-lg-4 col-md-6 portfolio-item filter-${item.category.toLowerCase()}`}>
              <img src={item.imageUrl} className="img-fluid" alt="" />
              <div className="portfolio-info">
                <h4>{item.title}</h4>
                <p>{item.category}</p>
                <a href={item.imageUrl} data-gallery="portfolioGallery" className="portfolio-lightbox preview-link" title={item.title}><i className="bx bx-plus"></i></a>
                <Link to={item.detailsPageUrl} className="details-link" title="More Details"><i className="bx bx-link"></i></Link>
              </div>
            </div>
          ))}
        </div>
        <div className="row">
          <div className="col-lg-12 d-flex justify-content-center">
            <div className="text-center">
              <Link to="/portfolio-viewer" className="btn btn-default btn-send" target="_blank" rel="noopener noreferrer">
                Download Full Portfolio
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSection;
